/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineGroupTypeEnum,
    DisciplineGroupTypeEnumFromJSON,
    DisciplineGroupTypeEnumFromJSONTyped,
    DisciplineGroupTypeEnumToJSON,
} from './DisciplineGroupTypeEnum';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';

/**
 * 
 * @export
 * @interface EditDisciplineGroupDTO
 */
export interface EditDisciplineGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof EditDisciplineGroupDTO
     */
    name?: string | null;
    /**
     * 
     * @type {DisciplineGroupTypeEnum}
     * @memberof EditDisciplineGroupDTO
     */
    type?: DisciplineGroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EditDisciplineGroupDTO
     */
    disiplineCount?: number;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof EditDisciplineGroupDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof EditDisciplineGroupDTO
     */
    studyYear?: StudyYearEnum;
}

export function EditDisciplineGroupDTOFromJSON(json: any): EditDisciplineGroupDTO {
    return EditDisciplineGroupDTOFromJSONTyped(json, false);
}

export function EditDisciplineGroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditDisciplineGroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : DisciplineGroupTypeEnumFromJSON(json['type']),
        'disiplineCount': !exists(json, 'disiplineCount') ? undefined : json['disiplineCount'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
    };
}

export function EditDisciplineGroupDTOToJSON(value?: EditDisciplineGroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': DisciplineGroupTypeEnumToJSON(value.type),
        'disiplineCount': value.disiplineCount,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'studyYear': StudyYearEnumToJSON(value.studyYear),
    };
}

